import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Divider = ({ text }) => {
    return (_jsxs("div", { className: "relative py-4", children: [_jsx("div", { className: "absolute inset-0 flex items-center", children: _jsx("div", { className: "w-full border-t border-gray-200" }) }), _jsx("div", { className: "relative flex justify-center", children: _jsx("span", { className: "rounded-full bg-gray-50 px-4 py-1 text-sm font-medium text-gray-500", children: text }) })] }));
};
export default Divider;
